import { render } from "./BlockAdminModal.vue?vue&type=template&id=6944f5df&scoped=true"
import script from "./BlockAdminModal.vue?vue&type=script&lang=js"
export * from "./BlockAdminModal.vue?vue&type=script&lang=js"

import "./BlockAdminModal.vue?vue&type=style&index=0&id=6944f5df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6944f5df"]])

export default __exports__